import { Link } from "react-router-dom";
import "./Disclaimer.css";

const Disclaimer = () => {
  return (
    <div className="disclaimer-page">
      <div className="disclaimer-container">
        <h1 className="disclaimer-title">Disclaimer</h1>
        {/* <p className="disclaimer-update">Last updated: Thursday, 17 April 2025</p> */}

        <div className="disclaimer-content">
          <p>
            The information on the{" "}
            <a href="https://healthwiibes.com/" className="disclaimer-link">
              healthwiibes.com
            </a>{" "}
            website is meant for general learning and providing a tool, the "BMI Ideal Weight Calculator," which also helps users to find the right diet for their bodies. While we try to keep the information accurate and up-to-date, we don't make any promises or guarantees about its completeness, accuracy, reliability, suitability, or availability for any purpose. You're using this information at your own risk.
          </p>

          <h2 className="disclaimer-subtitle">Consent</h2>
          <p>
            Now, by using this site, you agree to this disclaimer and accept its terms, and in the future we'll not be responsible for any damages experienced by using our tool or website. And if you don't agree with this disclaimer, then you can stop using our website.
          </p>

          <h2 className="disclaimer-subtitle">Professional Advice</h2>
          <p>
            The content on the site isn't a replacement for professional sources, although we will try our best to provide you information after full research on topics.
          </p>

          <h2 className="disclaimer-subtitle">External Links</h2>
          <p>
            The site may have links to other websites that we don't control or maintain. We can't guarantee the accuracy, relevance, timeliness, or completeness of the information on these external websites.
          </p>

          <h2 className="disclaimer-subtitle">Limitation of Liability</h2>
          <p>
            We, Healthwiibes, and our owners, contributors, employees, or affiliates, won't be responsible for any loss or damage, including indirect or consequential loss or damage.
          </p>

          <h2 className="disclaimer-subtitle">Changes to This Disclaimer</h2>
          <p>
            We can update or change our disclaimer anytime without telling you beforehand. Any changes will be posted on this page, and the effective date will be updated.
          </p>

          <h2 className="disclaimer-subtitle">Contact Us</h2>
          <p>
            If you have questions about this disclaimer, email us at{" "}
            <a href="mailto:healthwiibes@gmail.com" className="disclaimer-link">
              healthwiibes@gmail.com
            </a>
            .
          </p>

          <div className="disclaimer-conclusion">
            <p>
              By using HealthWibes, you agree to this disclaimer. If you don't agree, please don't use our website.
            </p>
          </div>
        </div>

        <div className="disclaimer-footer">
          <Link to="/" className="disclaimer-home-link">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;